import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export const VAT_OPTIONS = [
  { value: '0.085', label: '8.5 %' },
  { value: '0.021', label: '2.1 %' },
  { value: '0', label: '0 % (non applicable)' },
];

const VatRateSelect = ({ value, onChange, testId = 'vat-rate-select' }) => {
  const stringValue = (value === undefined || value === null) ? '0.085' : String(value);
  return (
    <Select value={stringValue} onValueChange={(v) => onChange(parseFloat(v))}>
      <SelectTrigger data-testid={testId}>
        <SelectValue placeholder="Taux TVA" />
      </SelectTrigger>
      <SelectContent>
        {VAT_OPTIONS.map((opt) => (
          <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default VatRateSelect;
